import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

export default function GridTextfield({
  id = "",
  key = "",
  name = "",
  columnSize = "6",
  label = "",
  multiline,
  currState = "",
  type = "text",
  rows = 1,
  error,
  helperText,
  onChange = null,
  variant = "outlined",
  required = true,
  isCurrency = false,
  disabled = false,
}) {
  return (
    <Grid size={Number(columnSize)}>
      <TextField
        id={id}
        variant={variant}
        label={label}
        fullWidth
        value={currState}
        type={type}
        multiline={multiline}
        rows={rows}
        error={error}
        helperText={helperText}
        required={required}
        disabled={disabled}
        onChange={(e, object) => onChange(e, object)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                {isCurrency ? "$" : ""}
              </InputAdornment>
            ),
          },
        }}
      />
    </Grid>
  );
}
